/* Product recommendations / recently viewed: fetch a rendered section and swap it in. */
(function () {
  'use strict';
  /* Secties nemen dit bestand elk zelf op, dus staat het soms twee of drie keer
     op één pagina. De browser voert elke tag dan opnieuw uit, waardoor listeners
     op document dubbel hangen en één klik twee acties uitvoert. Deze poort laat
     alleen de eerste uitvoering door. */
  window.__hwsLoaded = window.__hwsLoaded || {};
  if (window.__hwsLoaded['component_recommendations']) return;
  window.__hwsLoaded['component_recommendations'] = true;

  class HwsRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || this.dataset.loaded === 'true') return;
      var self = this;
      var run = function () {
        self.dataset.loaded = 'true';
        fetch(self.dataset.url)
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var parsed = new DOMParser().parseFromString(text, 'text/html');
            var source = parsed.querySelector('[data-recommendations-content]');
            if (!source || !source.innerHTML.trim()) { self.hidden = true; return; }
            if (self.dataset.extract === 'grid') {
              /* Embed in een tab: alleen het productgrid, niet de sectiekop. */
              var grid = source.querySelector('.product-grid');
              if (!grid) { self.hidden = true; return; }
              self.innerHTML = grid.outerHTML;
            } else {
              self.innerHTML = source.innerHTML;
            }
            if (window.hwsReveal) window.hwsReveal.scan();
          })
          .catch(function () { self.hidden = true; });
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            io.disconnect();
            run();
          });
        }, { rootMargin: '300px' });
        io.observe(this);
      } else { run(); }
    }
  }
  if (!customElements.get('hws-recommendations')) customElements.define('hws-recommendations', HwsRecommendations);

  class HwsRecentlyViewed extends HTMLElement {
    connectedCallback() {
      var base = this.dataset.sectionUrl;
      if (!base) return;
      var current = this.dataset.exclude || '';
      var handles = [];
      try { handles = JSON.parse(window.localStorage.getItem('hws:recently-viewed') || '[]'); } catch (e) { handles = []; }
      handles = handles.filter(function (h) { return h && h !== current; });
      if (!handles.length) { this.hidden = true; return; }
      var query = handles.slice(0, 10).map(function (h) { return 'handle:' + h; }).join(' OR ');
      var self = this;
      fetch(base + encodeURIComponent(query))
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var parsed = new DOMParser().parseFromString(text, 'text/html');
          var source = parsed.querySelector('[data-recently-viewed-content]');
          if (!source || !source.innerHTML.trim()) { self.hidden = true; return; }
          self.innerHTML = source.innerHTML;
          self.hidden = false;
          /* In de lade is weinig ruimte: daar hooguit drie regels. */
          var maximaal = parseInt(self.dataset.max, 10);
          if (maximaal > 0) {
            self.querySelectorAll('.product-grid > *').forEach(function (el, i) {
              if (i >= maximaal) el.remove();
            });
          }
          /* In de winkelwagen staat hieronder een lijst met populaire producten.
             Hebben we bekeken producten gevonden, dan zijn die relevanter en gaat
             die lijst weg — anders zou er twee keer een rij kaarten staan. */
          var vervangt = self.dataset.replaces;
          if (vervangt) {
            var root = self.closest('.cart-drawer__cross-sell, .cart-page__cross-sell') || document;
            root.querySelectorAll(vervangt).forEach(function (el) { el.hidden = true; });
          }
          if (window.hwsReveal) window.hwsReveal.scan();
        })
        .catch(function () { self.hidden = true; });
    }
  }
  if (!customElements.get('hws-recently-viewed')) customElements.define('hws-recently-viewed', HwsRecentlyViewed);
})();
